import React, { useState } from 'react';
import { useRecordContext, useDataProvider, useNotify } from 'react-admin';
import { actionType } from '../common';
import { LinearProgress, MenuItem, FormControl, Select } from '@mui/material';

interface IData {
    [key: string]: any;
}

/**
 * ActionField component for TrackingFailedOrders report
 */
const ActionField: React.FC<IData> = (props) => {
    const { setForRender } = props;
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [isLoading, setIsLoading] = useState(false);

    let record = useRecordContext();

    if (!record) return null;

    const handleChange = (props: any) => {
        let changedValue = props.target.value;
        if (changedValue === 'None' && !record.action) return;

        updateAction(changedValue);
    };

    /**
     * Updates the action type by calling UpdateActionType endpoint
     * Will insert new record with Category = "FailedTracking" or update existing
     */
    const updateAction = (value: any) => {
        let orderTracking = record;
        orderTracking.action = value === 'None' ? null : value;
        setIsLoading(true);

        dataProvider.postData('TrackingFailedOrders', 'UpdateActionType', orderTracking)
            .then((rs: any) => {
                if (rs.data) {
                    record.action = rs.data.action;
                    record.modified = rs.data.modified;
                    record.modified_By = rs.data.modified_By;
                    setForRender(record);
                    notify('Update successfully', { type: 'success', autoHideDuration: 2000 });
                }
                else if (rs.status === 400) {
                    notify(`Update failed(Bad request): ${rs.body}`, { type: 'error', autoHideDuration: 3000 });
                }
            })
            .catch((error: any) => {
                console.log('Update failed:', error);
                notify(`Update failed: Status ${error.status}, Error ${error}`, { type: 'error', autoHideDuration: 3000 });
            })
            .finally(_ => {
                setIsLoading(false);
            });
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 120, padding: 0 }} size="small" variant='standard'>
            {isLoading && <LinearProgress color="secondary" />}
            <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={record.action}
                defaultValue={record.action}
                disableUnderline={true}
                onChange={handleChange}
                sx={{ padding: 0 }}
            >
                {actionType.filter(err => err.value !== 'All').map((m, index) => {
                    return <MenuItem key={index} id={m.id} value={m.value} name={m.name}>{m.name}</MenuItem>;
                })}
            </Select>
        </FormControl>
    );
};
export default React.memo(ActionField);
